<template>
	<div>
		<p>And the fridge is bare - please check search criteria and try again!</p>
		<br/>
		<img id="cover_image" src="../assets/fridge.png" alt="no recipes found image " />
	</div>
</template>

<script>
export default {};
</script>

<style scoped>

p {
	color: #494d4e;
	font-family: 'Libre Franklin', 'Helvetica Neue', helvetica, arial, sans-serif;
}
</style>
